/* eslint-disable no-useless-escape */
/**
 * Key used in Localstorage to save the calendar access token
 */
export const KEY_CALENDAR_TOKEN = 'reload_calendar_token';

export const URL_REGEXP = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

export const EVENT_TYPES = {
  CENTER: 'CENTER',
  CLASSROOM: 'CLASSROOM',
  STUDENT: 'STUDENT',
};

export const TAGS = {
  TEACHER: 'teacher',
  ADMIN: 'admin',
  DIRECTOR: 'director',
};

export const EVENT_CALENDAR_TRIGGERS = {
  EVENT_CREATED: 'EVENT_CREATED',
  EVENT_MODIFIED: 'EVENT_MODIFIED',
  EVENT_DELETED: 'EVENT_DELETED',
  NEW_EVENT: 'NEW_EVENT',
  CALENDAR_VIEW: 'CALENDAR_VIEW',
  SELECT_DATE: 'SELECT_DATE',
  CALENDAR_EVENT_CLICKED: 'CALENDAR_EVENT_CLICKED',
};
